import IInitializableModule from '@episerver/spa-core/Core/IInitializableModule';
import IServiceContainer from '@episerver/spa-core/Core/IServiceContainer';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import IStateReducerInfo from '@episerver/spa-core/Core/IStateReducerInfo';
import SelfCareInvoiceBlockSlice from './SelfCareInvoiceBlockSlice';

export default class SelfCareInvoiceInitializableModule implements IInitializableModule {
  protected name: string = 'Self Care Invoice Block module';

  public GetName(): string {
    return this.name;
  }

  public ConfigureContainer(container: IServiceContainer): void {
  }

  public StartModule(context: IEpiserverContext): void {
  }

  public GetStateReducer(): IStateReducerInfo<any> | null {
    return {
      stateKey: 'selfCareInvoiceBlock',
      reducer: SelfCareInvoiceBlockSlice,
    };
  }
}
